import {BehaviorSubject} from 'rxjs';
import {PlaceOrderSide} from '@px/enum';
import {contractStorage} from '@px/storage/contract';

export const placeOrderSide$ = new BehaviorSubject<PlaceOrderSide>(readPlaceOrderSide());

placeOrderSide$.subscribe((side) => contractStorage.updateContractStorage({placeOrderSide: side}));

function readPlaceOrderSide(): PlaceOrderSide {
  const params = contractStorage.readContractStorage();
  if (params && params.placeOrderSide) {
    return params.placeOrderSide;
  }
  return PlaceOrderSide.Left;
}
